import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import ModalContext, { Modal } from './ModalContext';

interface Props {
  children?: ReactNode;
}

const ModalProvider: FC<Props> = ({ children }) => {
  const [modal, setModal] = useState<Modal | null>(null);

  const showModal = useCallback((options: Modal) => {
    setModal({
      variant: options.variant ?? 'info',
      header: options.header,
      body: options.body,
      button: options.button ?? 'Close',
      onClose: options.onClose,
      onButtonClick: options.onButtonClick,
    });
  }, []);

  const hideModal = useCallback(() => {
    setModal(null);
  }, []);

  const value = useMemo(
    () => ({
      modal,
      showModal,
      hideModal,
    }),
    [modal, showModal, hideModal],
  );

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};

export default ModalProvider;
